//NB - added case insensitivity (not sure where the original regex came from - but it was lowercase only)
export const EMAIL_REGEXP_RFC_5322 =
  /^(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
/**
 *
 * @param testEmail
 * @returns true is good
 */
export function emailFormatValidator(testEmail: string, required = true): boolean {
  let ret: boolean = !required;
  if (null != testEmail && testEmail.length > 0) {
    let invalid: boolean =
      testEmail.split(",").find((a: string) => !EMAIL_REGEXP_RFC_5322.test(a.trim())) != null;
    ret = !invalid;
  }
  return ret;
}
